module.exports = __webpack_public_path__ + "img/ico-pressure-normal-n.0d69becf.png";